import { Component, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { CustomFormValidators } from '@slickss/supplystack-components';

@Component({
    selector: 'supplystack-sidebar-search-value',
    templateUrl: './sidebar-search-value.component.html',
    styleUrls: ['./sidebar-search-value.component.scss']
})
export class SidebarSearchValueComponent {

    @Output()
    updateFilter: EventEmitter<any> = new EventEmitter();

    form: UntypedFormGroup;
    submittedForm = false;
    protected readonly customFormValidators = CustomFormValidators;

    constructor() {
        this.form = new UntypedFormGroup({
            value: new UntypedFormControl(null, [Validators.required])
        });
    }

    public apply($event) {

        this.submittedForm = true;

        if (!this.form.valid) {
            $event.stopPropagation();
        } else {

            const value = this.value.value;

            this.submittedForm = false;
            this.form.reset();
            this.form.updateValueAndValidity();

            this.updateFilter.emit(value);

        }

    }

    get value() { return this.form.get('value'); }

}
